import { defineMessages } from 'react-intl';

export default defineMessages({
    exitToDashBoard: {
        id: 'rewrite.eh.full.views.eh-confirmation.EXIT TO DASHBOARD',
        defaultMessage: 'EXIT'
    }
});
